import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./EditAgent.css";

const EditAgent = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    agentName: "",
    phoneNumber: "",
    nonAgence: "",
    territoire: "",
    langue: "",
    presentation: "",
    infosSupplementaires: "",
    adresse: "",
    photoProfil: "",
    password: "",
    confirmPassword: ""
  });

  const [photoFile, setPhotoFile] = useState(null);

  // Récupérer les infos de l'agent
  useEffect(() => {
    const fetchAgent = async () => {
      try {
        const response = await axios.get(
          `https://keurgui-backend-kjour.ondigitalocean.app/agents/${id}`
        );
        setFormData({
          ...response.data,
          password: "",
          confirmPassword: ""
        });
      } catch (error) {
        console.error("Erreur lors de la récupération de l'agent :", error);
        alert("Impossible de charger les données de l'agent.");
      }
    };

    fetchAgent();
  }, [id]);

  // Gestion des champs texte
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // Gestion du fichier
  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (file) setPhotoFile(file);
  };

  // Soumettre le formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Vérifier mot de passe
      if (formData.password && formData.password !== formData.confirmPassword) {
        alert("Les mots de passe ne correspondent pas");
        return;
      }

      // ⚡ Upload image si un fichier est sélectionné
      let imageUrl = formData.photoProfil;
      if (photoFile) {
        const formDataImg = new FormData();
        formDataImg.append("image", photoFile);

        const uploadRes = await axios.post(
          "https://keurgui-backend-kjour.ondigitalocean.app/api/upload",
          formDataImg,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        imageUrl = uploadRes.data.imageUrl;
      }

      // Préparer les données à envoyer
      const dataToSend = { ...formData, photoProfil: imageUrl };
      delete dataToSend.confirmPassword;
      if (!dataToSend.password) delete dataToSend.password;

      // Envoyer la requête PUT
      await axios.put(
        `https://keurgui-backend-kjour.ondigitalocean.app/agents/${id}`,
        dataToSend,
        { headers: { "Content-Type": "application/json" } }
      );

      alert("Agent modifié avec succès !");
      navigate("/admin");
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error.response || error);
      alert("Échec de la mise à jour de l'agent.");
    }
  };

  return (
    <div className="edit-agent-container">
      <h2>Modifier l'agent</h2>

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div>
          <label>Email :</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Nom de l'agent :</label>
          <input
            type="text"
            name="agentName"
            value={formData.agentName}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Numéro de téléphone :</label>
          <input
            type="text"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Agence :</label>
          <input
            type="text"
            name="nonAgence"
            value={formData.nonAgence}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Territoire :</label>
          <input
            type="text"
            name="territoire"
            value={formData.territoire}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Langue :</label>
          <input
            type="text"
            name="langue"
            value={formData.langue}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Présentation :</label>
          <textarea
            name="presentation"
            value={formData.presentation}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Infos supplémentaires :</label>
          <textarea
            name="infosSupplementaires"
            value={formData.infosSupplementaires}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Adresse :</label>
          <input
            type="text"
            name="adresse"
            value={formData.adresse}
            onChange={handleChange}
          />
        </div>

        {/* PHOTO PROFIL */}
        <div>
          <label>Photo de profil :</label>
          {formData.photoProfil && (
            <div style={{ marginBottom: 8 }}>
             <img
                src={formData.photoProfil} // utiliser directement l'URL renvoyée par l'upload DigitalOcean
                alt="Profil actuel"
                style={{
                  width: 80,
                  height: 80,
                  objectFit: "cover",
                  borderRadius: "50%"
                }}
              />
            </div>
          )}
          <input
            type="file"
            name="photoProfil"
            accept="image/*"
            onChange={handlePhotoUpload}
          />
          <small>Choisissez une nouvelle image pour remplacer l'actuelle</small>
        </div>

        {/* CHANGER MOT DE PASSE */}
        <div>
          <label>Nouveau mot de passe :</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Laisser vide si inchangé"
          />
        </div>

        <div>
          <label>Confirmer le mot de passe :</label>
          <input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
          />
        </div>

        <button type="submit">Enregistrer</button>
      </form>
    </div>
  );
};

export default EditAgent;